import {
  ACTIVE_AT_LOCATION_NAME,
  DISPLAY_ON_LOCATION_PAGE_NAME,
} from './ServiceItemLocationSettings.constants';

export function getSettingForLocation(settings, locationId) {
  return settings.find(({ locationId: id }) => id === locationId);
}

export function handleNewActiveAtLocationSettings(settings, locationId, value) {
  if (!value) {
    return settings.filter(({ locationId: settingLocationId }) => settingLocationId !== locationId);
  }

  return [...settings, { locationId, displayOnLocationPage: false }];
}

export function handleNewDisplayOnLocationPageSettings(settings, locationId, value) {
  return settings.map((setting) => {
    const { locationId: settingLocationId } = setting;
    if (settingLocationId === locationId) {
      return { ...setting, displayOnLocationPage: value };
    }
    return setting;
  });
}

export function getNewSettings(settings, locationId, name, value) {
  if (name === ACTIVE_AT_LOCATION_NAME) {
    return handleNewActiveAtLocationSettings(settings, locationId, value);
  }

  if (name === DISPLAY_ON_LOCATION_PAGE_NAME) {
    return handleNewDisplayOnLocationPageSettings(settings, locationId, value);
  }

  return settings;
}
